import { render, staticRenderFns } from "./ArrayData.vue?vue&type=template&id=e4df8038&scoped=true&"
import script from "./ArrayData.vue?vue&type=script&lang=js&"
export * from "./ArrayData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4df8038",
  null
  
)

export default component.exports